<template>
  <div class="graduation-page">
    <section class="graduation-hero">
      <img
        :src="assets.heroTop"
        alt="全国大学生毕业季工艺美术类优秀毕业作品大赛主视觉"
        class="graduation-hero__image"
      />
    </section>

    <main class="graduation-main">
      <section class="graduation-section graduation-objectives">
        <img :src="assets.objectives" alt="活动目的" class="section-title-image" />
        <div class="objective-layout">
          <div class="video-card">
            <video
              class="review-video"
              controls
              playsinline
              preload="metadata"
              :src="videoUrl"
            >
              当前浏览器不支持视频播放。
            </video>
          </div>
          <p>
            面向全国高等院校工艺美术专业应届毕业生，汇聚优质创新创意作品，展现全国院校当代工艺美术创意设计实力；促进国内院校间工艺美术学科交流，提升设计教育水平，推动产学融合，培育新生代文化创意设计力量；探讨工艺美术创新思路，建立国家级的工艺美术创意产品成果展示、评价、推广和支撑体系，通过征集创新作品的方式，发现和推介优秀作品和人才，围绕“创意工美”和“科技工美”两个主题进行遴选和推荐优秀作品，提升学生创作和教学品质，扩大学会的影响力。
          </p>
        </div>
      </section>

      <img :src="assets.organization" alt="组织机构" class="graduation-slice" />
      <img :src="assets.timeline" alt="大赛进程" class="graduation-slice" />

      <section class="white-band">
        <div class="graduation-main graduation-main-inner">
          <img :src="assets.awards" alt="奖项设置" class="graduation-slice" />
        </div>
      </section>

      <img :src="assets.collection" alt="作品征集" class="graduation-slice" />

      <section class="graduation-section submission-section">
        <img :src="assets.submissionIntro" alt="保送方式" class="section-title-image" />
        <div class="submission-body">
          <button class="download-button" type="button" @click="handleClickDownload">下载原创承诺书</button>
          <p class="muted">请提前下载并完整填写《原创承诺书》，在提交报名时一并上传</p>
          <img :src="assets.arrow" alt="" class="arrow-icon" />
          <h3>图片要求</h3>
          <p>分辨率要求为300-500dpi，JPG格式，每件（组）作品至少三张照片，包含细节图、整体图、正视图。</p>
          <img :src="assets.arrow" alt="" class="arrow-icon" />
          <h3>详细要求</h3>
          <ol>
            <li>提交作品需避免单独媒体显示器，作为展陈必需品。如果需要单独额外设备展示（包含除展柜外的其他展陈需求），需要作者随作品自行快递至展陈地址。</li>
            <li>作品效果展示若需灯光配合及用电需求，需在作品报名时正确勾选并详细说明。</li>
            <li>作品安装如需悬空展示，需提交作品展示多角度示例照片，明确三视图，确定吊点、占地面积及具体尺寸。</li>
            <li>若作品展示需进行现场组装，作者需随作品寄送展品安装视频全流程。</li>
          </ol>
          <img :src="assets.arrow" alt="" class="arrow-icon" />
          <h3>组委会联系人</h3>
          <p>刘茜茜: 13949085931<br />姚妞妞: 18611607763</p>
          <img :src="assets.arrow" alt="" class="arrow-icon" />
          <button class="signup-button" type="button" @click="handleClickToSign">立即报名</button>
        </div>
      </section>

      <img :src="assets.criteria" alt="评审标准" class="graduation-slice" />
      <img :src="assets.ip" alt="知识产权" class="graduation-slice" />
      <img :src="assets.statement" alt="声明" class="graduation-slice" />
      <img :src="assets.schools" alt="参赛院校名单" class="graduation-slice" />
    </main>

    <footer class="graduation-footer">
      <div>主办单位 中国工艺美术学会</div>
      <div>地址：北京市朝阳区建国路93号院万达广场 | 邮编：100022</div>
    </footer>

  </div>
</template>

<script>
import { activityDetail } from "@/api/Vote.js";
import { mapGetters } from "vuex";
import { downloadFileByUrl, resolveCommitmentTemplateUrl } from "@/utils/fileDownload";

const DEFAULT_ACTIVITY_ID = 5;
const DEFAULT_CONTEST_ROUTE_ID = "5";

export default {
  name: "Graduation",
  props: {
    activityIdOverride: {
      type: Number,
      default: 0,
    },
    contestRouteId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      videoUrl: "https://ykmk-master.oss-cn-shanghai.aliyuncs.com/wechat/%E6%AF%95%E4%B8%9A%E5%AD%A3%E5%A4%A7%E8%B5%9B%E8%A7%86%E9%A2%91.mp4",
      activityId: DEFAULT_ACTIVITY_ID,
      activityObj: {},
      categoryList: [],
      assets: {
        heroTop: require("@/assets/contest/graduation-2026/hero-top.png"),
        objectives: require("@/assets/contest/graduation-2026/Slice 268@2x.png"),
        organization: require("@/assets/contest/graduation-2026/Slice 268@2x(1).png"),
        timeline: require("@/assets/contest/graduation-2026/Slice 268@2x(2).png"),
        awards: require("@/assets/contest/graduation-2026/Slice 268@2x(8).png"),
        collection: require("@/assets/contest/graduation-2026/Slice 268@2x(9).png"),
        submissionIntro: require("@/assets/contest/graduation-2026/Slice 268@2x(3).png"),
        criteria: require("@/assets/contest/graduation-2026/Slice 268@2x(4).png"),
        ip: require("@/assets/contest/graduation-2026/Slice 268@2x(5).png"),
        statement: require("@/assets/contest/graduation-2026/Slice 268@2x(6).png"),
        schools: require("@/assets/contest/graduation-2026/Slice 268@2x(7).png"),
        arrow: require("@/assets/contest/graduation-2026/Slice 269@2x.png"),
      },
    };
  },
  computed: mapGetters(["userInfo", "isLogin"]),
  mounted() {
    this.getActivity();
  },
  methods: {
    getResolvedActivityId() {
      return Number(this.activityIdOverride || DEFAULT_ACTIVITY_ID);
    },
    getResolvedContestRouteId() {
      return String(this.contestRouteId || this.getResolvedActivityId() || DEFAULT_CONTEST_ROUTE_ID);
    },
    getActivity() {
      const activityId = this.getResolvedActivityId();
      activityDetail(activityId, { isShow: 0, uid: this.userInfo.uid | 0 }).then(res => {
        this.activityObj = res.data || {};
        this.categoryList = this.activityObj.categoryVos || [];
        this.activityId = this.activityObj.id || activityId;
      });
    },
    handleClickToSign() {
      this.$router.push("/ContestApply/" + this.getResolvedContestRouteId());
    },
    async handleClickDownload() {
      try {
        await downloadFileByUrl(
          resolveCommitmentTemplateUrl(this.activityObj),
          "原创承诺书",
          (this.activityObj && this.activityObj.updateTime) || Date.now()
        );
      } catch (error) {
        this.$message.error((error && error.message) || "原创承诺书模板下载失败");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.graduation-page {
  min-height: 100vh;
  background: #f4f6f8;
  color: #30343b;
}

.graduation-hero {
  width: 100%;
  overflow: hidden;
  background: #0b62bd;
}

.graduation-hero__image {
  display: block;
  width: 100%;
  height: auto;
  user-select: none;
}

.graduation-main {
  width: min(1220px, calc(100vw - 48px));
  margin: 0 auto;
  padding: 32px 0 46px;
}

.graduation-main-inner {
  padding: 0;
}

.graduation-section,
.graduation-slice {
  width: 100%;
}

.graduation-section {
  margin: 0 auto;
}

.section-title-image,
.graduation-slice {
  display: block;
  height: auto;
  user-select: none;
}

.section-title-image {
  width: 100%;
}

.graduation-slice {
  margin: 0 auto 42px;
}

.objective-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(0, 1fr);
  gap: 48px;
  align-items: start;
  padding: 24px 86px 30px;
}

.objective-layout p {
  margin: 0;
  color: #4b4f57;
  font-size: 17px;
  line-height: 2;
  text-align: justify;
}

.video-card {
  min-height: 0;
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 8px;
  overflow: hidden;
  background: #000;
}

.white-band {
  width: 100vw;
  margin-left: calc(50% - 50vw);
  margin-bottom: 42px;
  padding: 34px 0 28px;
  background: #fff;
}

.white-band .graduation-slice {
  margin-bottom: 0;
}

.submission-section {
  margin-bottom: 48px;
}

.submission-body {
  max-width: 1020px;
  margin: 0 auto;
  padding: 18px 0 4px;
  text-align: center;
  color: #3f444c;
  font-size: 15px;
  line-height: 1.9;
}

.submission-body p {
  margin: 8px auto;
}

.muted {
  color: #9a9fa8;
}

.arrow-icon {
  display: block;
  width: 38px;
  height: 38px;
  margin: 14px auto 8px;
}

.submission-body h3 {
  margin: 0 0 8px;
  color: #ff5b33;
  font-size: 18px;
}

.submission-body ol {
  width: min(820px, 100%);
  margin: 8px auto;
  padding-left: 1.3em;
  text-align: left;
}

.download-button,
.signup-button {
  min-width: 150px;
  height: 34px;
  padding: 0 28px;
  border: 0;
  border-radius: 999px;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
}

.download-button {
  background: #72c94b;
}

.signup-button {
  background: #ff4f2a;
}

.download-button:hover,
.signup-button:hover {
  filter: brightness(0.95);
}

.graduation-footer {
  width: min(1220px, calc(100vw - 48px));
  margin: 0 auto;
  padding: 10px 0 48px;
  color: #8b9098;
  font-size: 12px;
  line-height: 1.8;
}

.review-video {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
}

@media (max-width: 900px) {
  .graduation-main {
    width: calc(100vw - 24px);
    padding-top: 20px;
  }

  .graduation-slice {
    margin-bottom: 26px;
  }

  .objective-layout {
    grid-template-columns: 1fr;
    gap: 18px;
    padding: 18px 16px 28px;
  }

  .objective-layout p {
    font-size: 14px;
  }

  .video-card {
    aspect-ratio: 16 / 9;
  }

  .review-video {
    min-height: 0;
  }

  .white-band {
    margin-bottom: 26px;
    padding: 20px 0;
  }

  .submission-body {
    padding: 14px 12px 0;
    font-size: 14px;
  }

  .graduation-footer {
    width: calc(100vw - 24px);
  }
}
</style>
